import {Injectable} from '@angular/core';
import {StageService} from '../stage.service';
import {WallCutService} from './wall-cut.service';

@Injectable()
export class WallHolesService {

  constructor(private stage: StageService, private wallCutSrvc: WallCutService) {
  }

  update(wallName) {
    if (wallName) {
      const wall = this.stage.getObjectByName(wallName);
      this.wallCutSrvc.cutHoles(wall);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/wall/wall-holes.service.ts